module.exports = __webpack_public_path__ + "img/logo.abad022a.png";